import React from 'react';

import { selectSelectedAwardingBody, setAwardingBody } from 'store/exams-search/examsSearchSlice';
import { useAppDispatch, useAppSelector } from 'store';
import { useGetAwardingBodyQuery } from 'store/exams-search/examsSearchAPI';

import { ApiErrorPage, BcSelect } from '@britishcouncil/react-solas-ors3';
import { Alert, LoadingContainer } from '@britishcouncil/react-solas';

export const AwardingBodiesSelect = () => {
  const dispatch = useAppDispatch();
  const awardingBody = useAppSelector(selectSelectedAwardingBody);

  const { data: awardingBodies, error, isLoading } = useGetAwardingBodyQuery();

  if (error) return <ApiErrorPage />;

  return (
    <LoadingContainer loading={isLoading}>
      {awardingBodies && awardingBodies.length === 0 && (
        <Alert type="warning">There are currently no awarding bodies</Alert>
      )}
      {awardingBodies && awardingBodies.length > 0 && (
        <>
          <label htmlFor="awarding-body-select">Awarding body</label>
          <BcSelect
            id="awarding-body-select"
            isLoading={isLoading}
            options={awardingBodies}
            value={awardingBody}
            onChange={(selected: unknown) => dispatch(setAwardingBody(selected as string))}
            placeholder="Select awarding body"
          />
        </>
      )}
    </LoadingContainer>
  );
};
